export default function PageNotFound({
  message = "404 - Page Not Found",
}: {
  message?: string;
}) {
  return (
    <div>
      <h1>{message}</h1>
      <p>The page you are looking for cannot be found.</p>
    </div>
  );
}
